import autobind from 'core-decorators/lib/autobind';
import styles from './page-list.styl';

const PRE_RENDERED_COUNT = 1;

export default class PageList extends React.Component {

  static propTypes = {
    currentPageNumber: React.PropTypes.number,
    pageWidth: React.PropTypes.number,
    itemsByPageNumber: React.PropTypes.arrayOf(React.PropTypes.array),
    renderItem: React.PropTypes.func,
  };

  shouldRenderPage(pageIndex) {
    const { currentPageNumber } = this.props;
    return Math.abs(currentPageNumber - pageIndex) <= PRE_RENDERED_COUNT;
  }

  renderPageItems(pageIds, index) {
    const { renderItem } = this.props;
    return this.shouldRenderPage(index) ? _.map(pageIds, renderItem) : null;
  }

  @autobind
  renderPage(items, pageNumber) {
    const { pageWidth } = this.props;

    return (
      <div key={pageNumber}
           className={styles.page}
           style={{ width: pageWidth }}>
        {this.renderPageItems(items, pageNumber)}
      </div>
    );
  }

  render() {
    const { itemsByPageNumber } = this.props;

    return (
      <div className={styles.container}>
        {_.map(itemsByPageNumber, this.renderPage)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/page-list/page-list.js